<template>
    <SdsModal
        :title="$capitalize($t('error').toString())"
        size="md"
        @close="$emit('close')"
        styling="warning"
    >
        <template #default>
            {{ $t(textContent) }}
        </template>

        <template #dismiss-action="{ attrs, on }">
            <SdsButton
                v-bind="attrs"
                v-on="on"
                variant="primary"
            >
                <span class="capitalize">{{ $t(buttonLabel) }}</span>
            </SdsButton>
        </template>
    </SdsModal>
</template>

<script>
    import { get as _get } from 'lodash';
    import { mapGetters } from 'vuex';
    import {
        SdsModal,
        SdsButton,
    } from '@superbet-group/web.lib.ui-components';

    export default {
        name: 'ErrorModal',
        emits: ['close'],
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
            textContent() {
                return _get(this, 'modalData.text.content')
                    || 'Something went wrong. Please try again';
            },
            buttonLabel() {
                return _get(this, 'modalData.button.label') || 'ok';
            },
        },
        components: {
            SdsModal,
            SdsButton,
        },
    };
</script>
